export const state = {
  cities: []
}
